import {Box, Button, Chip, TableBody } from "@mui/material"
import 'moment-timezone';
import { formatDateTime } from "../../utils/DateTimeUtils";
import { Link } from "react-admin"
import { CustomTableRowTR, TableData } from "../../styles/commonStyles"

const CookServeTable =(props:any)=>{
    return (
        <>
        <TableBody>
            {
                props?.data.map((cook:any)=>{
                    return (
                        <CustomTableRowTR key={cook?.id} sx={cook?.notAvailable?{backgroundColor:"lightgrey !important"}:{}}>
                            <TableData>
                                <Box sx={{display:'flex', gap: 4, alignItems:'center'}}>
                                    <Link to={`/Cooks/${cook?.cookFullProfile?.cookId}/show`}>{cook?.cookFullProfile?.cookId}</Link>
                                </Box>
                            </TableData>
                            <TableData>{cook?.cookFullProfile?.firstName+" "+cook?.cookFullProfile?.lastName+" "}
                                <span style={{color:"green"}}>{(!cook?.previousRatingByCx&&!cook?.overallRating)?<></>:cook?.previousRatingByCx?cook?.previousRatingByCx+" By Cx":cook?.overallRating+" Avg"}</span>
                            </TableData>
                            <TableData>{cook?.cookFullProfile?.isMgCook ? "MG Cook" : "Part time"}</TableData>
                            <TableData>{cook?.slcName}</TableData>
                            <TableData>{cook?.mappingType}</TableData>
                            <TableData>
                                {
                                    <Box>{cook?.isBlackListed ?
                                        <Chip
                                            label={`Blocked`}
                                            size="small"
                                            sx={{
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                bgcolor: "#f5eae8",
                                                color: "red",
                                            }}
                                        /> : ''}
                                    </Box>
                                }
                                {cook?.matchedTags?.length > 0 ? (
                                    cook?.matchedTags.map((tag: string, index: number) => (
                                        <Chip
                                            key={`${tag}-${index}`}
                                            label={tag}
                                            size="small"
                                            sx={{
                                                mr: 0.5,
                                                mb: 0.5,
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                bgcolor: [
                                                    "#E3F2FD",
                                                    "#FFF3E0",
                                                    "#F3E5F5",
                                                    "#E0F7FA",
                                                    "#FBE9E7",
                                                ][index % 6],
                                                color: [
                                                    "#0D47A1",
                                                    "#E65100",
                                                    "#4A148C",
                                                    "#006064",
                                                    "#BF360C",
                                                ][index % 6],
                                            }}
                                        />
                                    ))
                                ) : (
                                    "-"
                                )}
                            </TableData>
                            <TableData>
                                {cook?.totalTags > 0 ? (
                                    cook?.matchedTags?.length === cook?.totalTags ? (
                                        <Chip
                                            label={`✓ All matched`}
                                            size="small"
                                            sx={{
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                bgcolor: "#E8F5E9",
                                                color: "#1B5E20",
                                            }}
                                        />
                                    ) : cook?.matchedTags?.length > 0 ? (
                                        <Chip
                                            label={`~ Partial match ${cook?.matchedTags?.length}/${cook?.totalTags}`}
                                            size="small"
                                            sx={{
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                bgcolor: "#FFF3E0",
                                                color: "#E65100",
                                            }}
                                        />
                                    ) : (
                                        <Chip
                                            label="No match"
                                            size="small"
                                            sx={{
                                                fontWeight: 600,
                                                borderRadius: 2,
                                                bgcolor: "#FFEBEE",
                                                color: "#B71C1C",
                                            }}
                                        />
                                    )
                                ) : (
                                    <Chip
                                        label="No preference"
                                        size="small"
                                        sx={{
                                            fontWeight: 600,
                                            borderRadius: 2,
                                            bgcolor: "#ECEFF1",
                                            color: "#455A64",
                                        }}
                                    />
                                )}
                            </TableData>
                            <TableData>{(!cook?.notAvailable&&cook?.currentAvailableSlot)?cook?.currentAvailableSlot:"-"}</TableData>
                            <TableData>{(!cook?.notAvailable&&cook?.nextAvailableSlot)?cook?.nextAvailableSlot:"-"}</TableData>
                            <TableData>
                                {cook?.distanceFromHouseToCookLastLocation ? `${(Number(cook?.distanceFromHouseToCookLastLocation || 0) / 1000).toFixed(1)} km` : "N/A"}
                            </TableData>
                            <TableData sx={{ whiteSpace: 'nowrap', minWidth: '160px' }}>
                                {formatDateTime(cook?.locationFetchTime)}
                            </TableData>
                            <TableData><Button onClick={()=>{
                                props?.setDialogOpen(true);
                                props?.setCook(cook?.cookFullProfile?.cookId);
                            }} variant="contained">Show Slots</Button>
                            </TableData>
                            {
                                props?.hasService?<TableData><Button onClick={()=>{
                                    props?.setAssignCookOpen(true);
                                    props?.setCook(cook?.cookFullProfile?.cookId);
                                }} variant="contained">Assign</Button>
                                </TableData>:<></>
                            }
                        </CustomTableRowTR>
                    )
                })
            }    
        </TableBody>
        </>
    )
}
export default CookServeTable
